import { render, staticRenderFns } from "./NewSystemMod.vue?vue&type=template&id=3b1c6b9c&scoped=true"
import script from "./NewSystemMod.vue?vue&type=script&lang=js"
export * from "./NewSystemMod.vue?vue&type=script&lang=js"
import style0 from "./NewSystemMod.vue?vue&type=style&index=0&id=3b1c6b9c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1c6b9c",
  null
  
)

export default component.exports